import React from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "./CartContext";
import "./Payment.css";

function Payment() {
  const navigate = useNavigate();

  const {
    cartItems,
    cartTotal,
    increaseQuantity,
    decreaseQuantity,
    removeFromCart,
  } = useCart();

  const handlePlaceOrder = () => {
    alert("Payment integration will be connected here.");
  };

  return (
    <div className="payment-page">

      {/* =========================
          HEADER
      ========================= */}

      <div className="payment-header">
        <button
          className="back-cart-btn"
          onClick={() => navigate("/cart")}
        >
          ← Back to Cart
        </button>

        <h1>Checkout</h1>

        <span className="secure-text">
          🔒 Secure Checkout
        </span>
      </div>


      {/* =========================
          MAIN CONTAINER
      ========================= */}

      <div className="payment-container">

        {/* =========================
            LEFT SIDE
        ========================= */}

        <div className="payment-left">

          {/* DELIVERY ADDRESS */}

          <div className="payment-box">

            <div className="box-title">
              <span className="step-number">1</span>

              <div>
                <h2>Delivery Address</h2>
                <p>Where should we deliver your order?</p>
              </div>
            </div>

            <div className="address-form">

              <div className="form-row">

                <input
                  type="text"
                  placeholder="First Name"
                />

                <input
                  type="text"
                  placeholder="Last Name"
                />

              </div>

              <input
                type="text"
                placeholder="Address"
              />

              <input
                type="text"
                placeholder="Apartment, suite, etc. (optional)"
              />

              <div className="form-row">

                <input
                  type="text"
                  placeholder="City"
                />

                <input
                  type="text"
                  placeholder="Postcode"
                />

              </div>

              <input
                type="tel"
                placeholder="Phone Number"
              />

              <input
                type="email"
                placeholder="Email Address"
              />

            </div>

          </div>


          {/* =========================
              PAYMENT METHODS
          ========================= */}

          <div className="payment-box">

            <div className="box-title">

              <span className="step-number">
                2
              </span>

              <div>
                <h2>Payment Method</h2>

                <p>
                  Choose your preferred payment method
                </p>
              </div>

            </div>


            {/* PAYMENT OPTIONS */}

            <div className="payment-methods">

              {/* CARD */}

              <div className="payment-method">

                <input
                  type="radio"
                  name="payment"
                  defaultChecked
                />

                <div className="payment-method-content">

                  <strong>
                    💳 Credit / Debit Card
                  </strong>

                  <span>
                    Visa, Mastercard, American Express
                  </span>

                </div>

              </div>


              {/* APPLE PAY */}

              <div className="payment-method">

                <input
                  type="radio"
                  name="payment"
                />

                <div className="payment-method-content">

                  <strong>
                     Apple Pay
                  </strong>

                  <span>
                    Pay securely with Apple Pay
                  </span>

                </div>

              </div>


              {/* Razorpay PAY */}

              <div className="payment-method">

                <input
                  type="radio"
                  name="payment"
                />

                <div className="payment-method-content">

                  <strong>
                    Razorpay
                  </strong>

                  <span>
                    Fast and secure Google Pay
                  </span>

                </div>

              </div>


              {/* stripe */}

              <div className="payment-method">

                <input
                  type="radio"
                  name="payment"
                />

                <div className="payment-method-content">

                  <strong>
                    Stripe 
                  </strong>

                  <span>
                    Pay securely with PayPal
                  </span>

                </div>

              </div>


              {/* OTHER */}

              <div className="payment-method">

                <input
                  type="radio"
                  name="payment"
                />

                <div className="payment-method-content">

                  <strong>
                    Cash On Delivery
                  </strong>

                  <span>
                    Other payment methods available for your location
                  </span>

                </div>

              </div>

            </div>

          </div>


          {/* =========================
              SECURITY
          ========================= */}

          <div className="payment-security">

            <span className="security-icon">
              🔒
            </span>

            <div>

              <strong>
                Your payment is secure
              </strong>

              <p>
                Your payment information is encrypted
                and securely processed.
              </p>

            </div>

          </div>

        </div>


        {/* =========================
            RIGHT SIDE - ORDER SUMMARY
        ========================= */}

        <div className="payment-right">

          <div className="order-summary">

            <h2>
              Your Order
            </h2>


            {/* PRODUCTS */}

            <div className="payment-products">

              {cartItems.length === 0 ? (

                <div className="empty-payment-cart">

                  <p>
                    Your cart is empty.
                  </p>

                  <button
                    onClick={() =>
                      navigate("/view-all")
                    }
                  >
                    Continue Shopping
                  </button>

                </div>

              ) : (

                cartItems.map((item) => (

                  <div
                    className="payment-product"
                    key={item.id}
                  >

                    {/* IMAGE */}

                    <div className="payment-product-image">

                      <img
                        src={item.img}
                        alt={item.name}
                      />

                      <span>
                        {item.quantity}
                      </span>

                    </div>


                    {/* DETAILS */}

                    <div className="payment-product-info">

                      <h3>
                        {item.name}
                      </h3>

                      <p>
                        £{Number(item.price).toFixed(2)}
                      </p>


                      {/* QUANTITY */}

                      <div className="payment-quantity">

                        <button
                          onClick={() =>
                            decreaseQuantity(item.id)
                          }
                        >
                          −
                        </button>

                        <span>
                          {item.quantity}
                        </span>

                        <button
                          onClick={() =>
                            increaseQuantity(item.id)
                          }
                        >
                          +
                        </button>

                        <button
                          className="payment-remove"
                          onClick={() =>
                            removeFromCart(item.id)
                          }
                        >
                          Remove
                        </button>

                      </div>

                    </div>


                    {/* ITEM TOTAL */}

                    <strong className="item-total">

                      £
                      {(
                        Number(item.price) *
                        item.quantity
                      ).toFixed(2)}

                    </strong>

                  </div>

                ))

              )}

            </div>


            {/* TOTALS */}

            {cartItems.length > 0 && (

              <>

                <div className="summary-line">

                  <span>
                    Subtotal
                  </span>

                  <span>
                    £{Number(cartTotal).toFixed(2)}
                  </span>

                </div>


                <div className="summary-line">

                  <span>
                    Delivery
                  </span>

                  <span>
                    FREE
                  </span>

                </div>


                <div className="summary-line">

                  <span>
                    VAT / Taxes
                  </span>

                  <span>
                    Calculated at checkout
                  </span>

                </div>


                <div className="summary-total">

                  <span>
                    Total
                  </span>

                  <strong>
                    £{Number(cartTotal).toFixed(2)}
                  </strong>

                </div>


                {/* PAY BUTTON */}

                <button
                  className="place-order-btn"
                  onClick={handlePlaceOrder}
                >
                  🔒 Pay £
                  {Number(cartTotal).toFixed(2)}
                </button>


                <p className="terms-text">

                  By continuing, you agree to our
                  Terms & Conditions and Privacy Policy.

                </p>

              </>

            )}

          </div>

        </div>

      </div>

    </div>
  );
}

export default Payment;

